<template>
    <div v-if="isShow" class="tomax" @click="isShow=false" >
        <img :src="url" width="500px" height="500px"/>
    </div>
</template>
<script>
import equ04  from '@/assets/images/equ04.jpg'
export default {
    props:{
        isShow:{
            type:Boolean,
            default:false
        },
        url:{
            type:String,
            default:equ04
        }
    },
    watch:{
        isShow (newval, oldval) {
           
        }
    },
    data(){
        return {
            
        }
    }

}
</script>
<style scoped>
.tomax{
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.75);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000000002;
    display: flex;
    align-items: center;
    justify-content: center;
}
.maximg{
object-fit: contain;
}
</style>